var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pause") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.960784 0 0 0 0 0.709804 0 0 0 0 0.298039 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBule---Milestone-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-copy-11",
    transform: "translate(-1028.000000, -24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.Icons-/-Basic-/-Solid-/-Dot-Copy",
    transform: "translate(1027.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "pause"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9892683,0 C4.91769756,0 0,4.91769756 0,10.9892683 C0,17.060839 4.91769756,21.9785366 10.9892683,21.9785366 C17.060839,21.9785366 21.9785366,17.060839 21.9785366,10.9892683 C21.9785366,4.91769756 17.060839,0 10.9892683,0 Z M9.78044878,13.7365854 C9.78044878,14.4234146 9.23098537,14.9454049 8.57162927,14.9454049 C7.8848,14.9454049 7.36280976,14.3959415 7.36280976,13.7365854 L7.36280976,8.24195122 C7.33533659,7.58259512 7.8848,7.03313171 8.5441561,7.03313171 C9.23098537,7.03313171 9.78044878,7.58259512 9.78044878,8.24195122 L9.78044878,13.7365854 Z M14.6432,13.7365854 C14.6432,14.4234146 14.0937366,14.9454049 13.4343805,14.9454049 C12.7475512,14.9454049 12.225561,14.3959415 12.225561,13.7365854 L12.225561,8.24195122 C12.1980878,7.58259512 12.7475512,7.03313171 13.4069073,7.03313171 C14.0937366,7.03313171 14.6432,7.58259512 14.6432,8.24195122 L14.6432,13.7365854 Z",
    id: "Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/PauseIcon.1faedd67ac51ffdf5d17249ada0b7709.svg";
export { ForwardRef as ReactComponent };